"use client"
import { Component } from "react"
import redux from "../../common/Redux"
import Table from "../../components/Table"
import Header from "../../components/Header"
import Toast from "../../components/Toast"
import API from "../../services/API"
import { URL_PATH } from "../../services/API"
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  TextField,
  FormControl,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  Button,
  Collapse,
  Switch,
  FormControlLabel,
  Box,
  Divider,
  Avatar
} from "@mui/material"
import { ExpandMore, ExpandLess } from "@mui/icons-material"

class ListGatewaysScreen extends Component {
 constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: true,
      error: null,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      easebuzzExpanded: false,
      onlinePaymentEnabled: false,
      bankDetails: {
        bank_acc_holder_name: "",
        bank_name: "",
        bank_branch_name: "",
        bank_account_number: "",
        ifsc_code: "",
        currency: "INR",
      },
      bankDetailsFilled: false,
      configLoading: true
    }
  }

  componentDidMount() {
    this.fetchHotelProfile()
    this.fetchConfig()
  }

  fetchConfig = async () => {
    const response = await API(this, "get", URL_PATH.GET_PREFERENCES)
    const { status, message, data } = response

    if (status === "success") {
      const { hotelConfig } = data
      this.setState({
        onlinePaymentEnabled: hotelConfig.online_payment,
        configLoading: false
      })
    }
  }

  fetchHotelProfile = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.hotelProfile(this.props.selectedHotelId.id))
  
    if (status == "success") {
      const bankDetailsFilled = data.bank_acc_holder_name && 
                              data.bank_name && 
                              data.bank_account_number && 
                              data.ifsc_code
      
      this.setState({
        bankDetails: {
          bank_acc_holder_name: data.bank_acc_holder_name || "",
          bank_name: data.bank_name || "",
          bank_branch_name: data.bank_branch_name || "",
          bank_account_number: data.bank_account_number || "",
          ifsc_code: data.ifsc_code || "",
          currency: data.currency || "INR",
        },
        bankDetailsFilled,
        mounted: true,
        loading: false
      })
    }
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  toggleEasebuzz = () => {
    this.setState({ easebuzzExpanded: !this.state.easebuzzExpanded })
  }

  handleBankDetailsChange = (e) => {
    const { name, value } = e.target
    this.setState({
      bankDetails: {
        ...this.state.bankDetails,
        [name]: value,
      },
    })
  }

  handleOnlinePaymentToggle = async (event) => {
    const { checked } = event.target
    const { bankDetailsFilled } = this.state

    if (checked && !bankDetailsFilled) {
      this.showToast("Please fill bank details first to enable online payments", "error")
      return
    }

    try {
      this.setState({ onlinePaymentEnabled: checked })
      
      const fd = {
        online_payment: checked
      }

      const { status, message } = await API(this, "post", URL_PATH.saveConfig, fd)

      if (status === "success") {
        this.showToast(`Online payments ${checked ? "enabled" : "disabled"}`, "success")
      } else {
        this.setState({ onlinePaymentEnabled: !checked })
        this.showToast(message || "Failed to update payment settings", "error")
      }
    } catch (error) {
      this.setState({ onlinePaymentEnabled: !checked })
      this.showToast("An error occurred while updating payment settings", "error")
      console.error("Error updating payment settings:", error)
    }
  }

  submitBankDetails = async () => {
    const { bankDetails } = this.state
  
    // Validate fields
    if (
      !bankDetails.bank_acc_holder_name ||
      !bankDetails.bank_name ||
      !bankDetails.bank_account_number ||
      !bankDetails.ifsc_code
    ) {
      this.showToast("Please fill all required fields", "error")
      return
    }
  
    try {
      const token = localStorage.getItem('token')
  
      if (!token) {
        this.showToast("Authentication token missing", "error")
        return
      }
  
      const formData = new URLSearchParams()
      formData.append('currency', bankDetails.currency || 'INR')
      formData.append('bank_branch_name', bankDetails.bank_branch_name)
      formData.append('bank_account_number', bankDetails.bank_account_number)
      formData.append('ifsc_code', bankDetails.ifsc_code)
      formData.append('bank_acc_holder_name', bankDetails.bank_acc_holder_name)
      formData.append('bank_name', bankDetails.bank_name)
  
      const response = await API(
        this,
        "post",
        URL_PATH.bankDetailsHotel(this.props.selectedHotelId.id),
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`
          }
        }
      )
  
      if (response.status === "success") {
        this.setState({ bankDetailsFilled: true })
        this.showToast("Bank details updated successfully", "success")
      } else {
        this.showToast(response.message || "Failed to update bank details", "error")
      }
    } catch (error) {
      this.showToast("An error occurred while updating bank details", "error")
      console.error("Error updating bank details:", error)
    }
  }
  render() {
    const { toast, easebuzzExpanded, bankDetails, onlinePaymentEnabled, loading, configLoading } = this.state

    if (loading || configLoading) {
      return (
        <Box>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                padding: 15,
                alignSelf: "center",
                borderRadius: "50%",
              }}
            >
              <img
                src={"/Etable Loading.gif"}
                style={{
                  width: 180,
                  height: 180,
                }}
                className="fade-in"
              />
            </div>
          </div>
        </Box>
      )
    }

    return (
      <div className="container-fluid">
        <Header title="Payment Integrations" />

        <Card sx={{ 
          mb: 4, 
          backgroundColor: "#02111B", 
          backgroundImage: "none",
          border: "1px solid #FFC857",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)"
        }}>
          <CardHeader
            avatar={
              <Avatar 
                src="/easebuzz-logo.png" 
                alt="Easebuzz" 
                sx={{ 
                  width: 56, 
                  height: 56,
                  backgroundColor: '#FFC857',
                  padding: 1,
                  border: '1px solid #FFC857'
                }} 

              />
            }
            title={
              <Typography variant="h5" sx={{ color: "white", fontWeight: 600 }}>
                Easebuzz Payment Gateway
              </Typography>
            }
            subheader={
              <Typography variant="body2" sx={{ color: "white", mt: 0.5 }}>
                Securely accept online payments from your customers
              </Typography>
            }
            action={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  onClick={this.toggleEasebuzz}
                  endIcon={easebuzzExpanded ? <ExpandLess /> : <ExpandMore />}
                  sx={{ 
                    color: "white",
                    textTransform: 'none',
                    fontWeight: 500
                  }}
                >
                  {easebuzzExpanded ? "Hide settings" : "Configure"}
                </Button>
              </Box>
            }
            sx={{ 
              borderBottom: "1px solid #9D9D9D",
              padding: "16px 24px"
            }}
          />
          
          <Collapse in={easebuzzExpanded}>
            <CardContent sx={{ padding: "24px" }}>
              <Box sx={{ 
                backgroundColor: "#041A29", 
                p: 3, 
                mb: 3, 
                borderRadius: "8px",
                borderLeft: "4px solid #0D6EFD"
              }}>
                <Box sx={{ 
                  display: "flex", 
                  justifyContent: "space-between", 
                  alignItems: "center",
                  mb: 2
                }}>
                  <Box>
                    <Typography variant="h6" sx={{ color: "white", fontWeight: 500 }}>
                      Online Payment Status
                    </Typography>
                    <Typography variant="body2" sx={{ color: "white" }}>
                      {onlinePaymentEnabled ? 
                        "Payments are currently being accepted" : 
                        "Payments are currently disabled"}
                    </Typography>
                  </Box>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={onlinePaymentEnabled}
                        onChange={this.handleOnlinePaymentToggle}
                        color="primary"
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: "#0D6EFD",
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: "#0D6EFD",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body1" sx={{ 
                        color: onlinePaymentEnabled ? "white" : "#666",
                        fontWeight: 500
                      }}>
                        {onlinePaymentEnabled ? "ACTIVE" : "INACTIVE"}
                      </Typography>
                    }
                    labelPlacement="start"
                  />
                </Box>
                
                {!onlinePaymentEnabled && (
                  <Typography variant="body2" sx={{ 
                    color: "#d32f2f", 
                    backgroundColor: "#ffebee",
                    p: 1,
                    borderRadius: "4px",
                    display: "inline-block"
                  }}>
                    Note: Bank details must be configured before enabling payments
                  </Typography>
                )}
              </Box>

              <Typography variant="h6" sx={{ 
                color: "white", 
                fontWeight: 500,
                mb: 3,
                display: 'flex',
                alignItems: 'center'
              }}>
                
                Bank Account Details
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    required
                    label="Account Holder Name"
                    name="bank_acc_holder_name"
                    value={bankDetails.bank_acc_holder_name}
                    onChange={this.handleBankDetailsChange}
                    variant="outlined"
                    
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    required
                    label="Bank Name"
                    name="bank_name"
                    value={bankDetails.bank_name}
                    onChange={this.handleBankDetailsChange}
                    variant="outlined"
                    
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Branch Name"
                    name="bank_branch_name"
                    value={bankDetails.bank_branch_name}
                    onChange={this.handleBankDetailsChange}
                    variant="outlined"
                    
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    required
                    label="Account Number"
                    name="bank_account_number"
                    value={bankDetails.bank_account_number}
                    onChange={this.handleBankDetailsChange}
                    variant="outlined"
                  
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    required
                    label="IFSC Code"
                    name="ifsc_code"
                    value={bankDetails.ifsc_code}
                    onChange={this.handleBankDetailsChange}
                    variant="outlined"
                   
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="currency-select-label" sx={{ color: "#666" }}>
                      Currency
                    </InputLabel>
                    <Select
                      label="Currency"
                      name="currency"
                      value={bankDetails.currency || "INR"}
                      onChange={this.handleBankDetailsChange}
                      
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root": {
                              "&:hover": {
                                backgroundColor: "#f3f3f3",
                              },
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem value="INR">INR (Indian Rupee)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Box sx={{ 
                mt: 4,
                display: 'flex',
                justifyContent: 'flex-start',
                gap: 2
              }}>
                <Button
                  variant="outlined"
                  onClick={this.toggleEasebuzz}
                  sx={{
                    color: "white",
                     fontWeight: "700",
                   borderColor: "#BB0A21",
                    "&:hover": {
                      borderColor: "#BB0A21",
                    },
                    backgroundColor: "#BB0A21",
                    "&:hover": {
                      backgroundColor: "#BB0A21",
                    },
                   
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={this.submitBankDetails}
                  sx={{
                    color: "black",
                    fontWeight: "700",
                    backgroundColor: "#FFC857",
                    "&:hover": {
                      backgroundColor: "#FFC857",
                    },
                  }}
                >
                  Save Bank Details
                </Button>
              </Box>
            </CardContent>
          </Collapse>
        </Card>

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(ListGatewaysScreen)